module.exports = __webpack_public_path__ + "img/52float.31ccdd1.png";